import React from "react";
import { Grid, Section, Breadcrumb } from "@boozallen-uip/uswds-react-core";
import PageHeader from "../components/PageHeader/PageHeader.component";
import { BASE_TITLE, HOME_URL, TERMS_OF_USE_URL } from "../utlities/core.constants";

export default function TermsOfUse() {
  document.title = `${BASE_TITLE} - Terms of Use`;

  return (
    <Section className="pt-0" id="terms_of_use_container">
      <PageHeader backgroundColor="var(--color-primary)">
        Terms of Use
      </PageHeader>
      <Grid>
        <Grid.Row>
          <Grid.Col>
            <Breadcrumb links={[{ href: HOME_URL, text: "Home" }, { href: TERMS_OF_USE_URL, text: "Terms of Use" }]} />
            <h1 className="text-primary text-[32px] font-normal">ACR Repository Terms of Use</h1>
            <p className="text-primary-darker text-base leading-normal">
              By creating a profile or submitting content to ACR Repository, you agree to the following terms.
            </p>

            <h2 className="text-primary-darker text-xl font-bold">Content Standards</h2>
            <p className="text-primary-darker text-base leading-normal">
              Vendors are responsible for ensuring that all information they submit is accurate, appropriate, and relevant to their organization.
            </p>
            <p className="text-primary-darker text-base leading-normal">Content must not:</p>
            <ul className="text-primary-darker text-base leading-normal list-disc pl-6">
              <li>Contain abusive, threatening, harassing, hateful, discriminatory, or excessively offensive language.</li>
              <li>Contain obscene, sexually explicit, or otherwise objectionable material.</li>
              <li>Make defamatory, knowingly false, or misleading statements about individuals or organizations.</li>
              <li>Promote illegal activity, violence, or discrimination.</li>
              <li>Contain spam, malicious content, or material unrelated to the purpose of ACR Repository.</li>
              <li>Violate any applicable law or the rights of others.</li>
              <li>Contain PII.</li>
            </ul>

            <h2 className="text-primary-darker text-xl font-bold">Administrator Rights</h2>
            <p className="text-primary-darker text-base leading-normal">
              ACR Repository administrators reserve the right to review, edit, restrict, or remove any content that, in their reasonable judgment, violates these Terms or is inappropriate for the Site.
            </p>
            <p className="text-primary-darker text-base leading-normal">
              Administrators may correct language, formatting, or other content to maintain a professional and consistent platform. Content may be modified or removed without prior notice when necessary.
            </p>
            <p className="text-primary-darker text-base leading-normal">
              ACR Repository may also suspend or remove profiles that repeatedly or seriously violate these Terms.
            </p>

            <h2 className="text-primary-darker text-xl font-bold">Vendor Responsibility</h2>
            <p className="text-primary-darker text-base leading-normal">
              Vendors are responsible for the content they submit and must have the necessary rights and permissions to publish it. Publication on ACR Repository does not constitute an endorsement by the U.S. Government or verification of the information provided.
            </p>

            <h2 className="text-primary-darker text-xl font-bold">Changes to These Terms</h2>
            <p className="text-primary-darker text-base leading-normal">
              ACR Repository may update these Terms at any time. Continued use of the Site after changes are posted constitutes acceptance of the revised Terms.
            </p>
            <p className="text-primary-darker text-base leading-normal">
              By using ACR Repository, you acknowledge and agree to these Terms of Use.
            </p>
          </Grid.Col>
        </Grid.Row>
      </Grid>
    </Section>
  );
}
